var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFacebook28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14 2a12 12 0 0 0-1.875 23.854V17.47H9.078v-3.47h3.047v-2.643c0-3.007 1.791-4.669 4.532-4.669.9.013 1.798.091 2.687.235v2.953H17.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385A12.001 12.001 0 0 0 14 2Z"
})));
export { SvgFacebook28 as ReactComponent };
export default __webpack_public_path__ + "ee13b524b245766928dc90e36898616a.svg";